//行情路由
export default [{
  path: 'bidMarketList',
  name: 'bidMarketList',
  component: function component() {
    return import('@/components/basicData/marketManage/bid/index');
  }
}, {
  path: 'recoveryMarketList',
  name: 'recoveryMarketList',
  component: function component() {
    return import('@/components/basicData/marketManage/recovery/index');
  }
}];